/* eslint-disable no-bitwise, global-require */
import dbg from 'debug';

const debug = dbg('jp:analytics');

let instance = null;

const prodConfig = {
  AdWords: {
    conversionId: '1065433872'
  },
  'Facebook Pixel': {
    pixelId: '540636262740875'
  },
  'Google Analytics': {
    trackingId: 'UA-11508076-1'
  },
  Mixpanel: {
    consolidatedPageCalls: false,
    token: '227ff3f622bc8de131254686178755ca',
    trackNamedPages: true,
    crossSubdomainCookie: true,
    eventIncrements: [],
    legacySuperProperties: false,
    people: false,
    peopleProperties: [],
    persistence: 'cookie',
    propIncrements: [],
    secureCookie: false,
    setAllTraitsByDefault: true,
    superProperties: [],
    trackAllPages: false,
    trackCategorizedPages: true
  },
  'Twitter Ads': {
    page: 'l4swr'
  }
};

const stagingConfig = {
  AdWords: { conversionId: '1065433872' },
  'Facebook Pixel': { pixelId: '540636262740875' },
  'Google Analytics': { trackingId: 'UA-11508076-6' },
  Mixpanel: {
    consolidatedPageCalls: false,
    crossSubdomainCookie: true,
    eventIncrements: [],
    legacySuperProperties: false,
    people: false,
    peopleProperties: [],
    persistence: 'cookie',
    propIncrements: [],
    secureCookie: false,
    setAllTraitsByDefault: true,
    superProperties: [],
    trackAllPages: false,
    trackCategorizedPages: true,
    token: 'aa8496acc07d2a32659aa70607c65302',
    trackNamedPages: true
  },
  'Twitter Ads': { page: 'l4swr' }
};

if (__CLIENT__) {
  window.jpAnalyticsConfig =
    process.env.NODE_ENV === 'production' ? prodConfig : stagingConfig;
}

export default class Analytics {
  constructor() {
    if (instance) {
      return instance;
    }

    this.defaultProperties = {};
    this.tracking = null;

    if (!instance && __CLIENT__ && process.env.NODE_ENV !== 'test') {
      instance = this;
      return instance;
    }

    return {
      page: () => {},
      identify: () => {},
      track: () => {},
      reset: () => {},
      setDefaultProperties: () => {}
    };
  }

  getTracking() {
    if (this.tracking !== null) {
      return this.tracking;
    }

    this.tracking = import(/* webpackChunkName: "jp-analytics" */ 'jp-analytics')
      .then(({ default: analytics }) =>
        analytics(process.env.JP_ANALYTICS_CLIENT_ID, {
          JustPark: {
            baseUrl: process.env.JP_ANALYTICS_URL
          }
        })
      )
      .then(
        tracking =>
          new Promise(resolve => {
            resolve(tracking);

            if (typeof tracking.ready !== 'function') {
              return;
            }

            if ('ga' in window) {
              // Preload ecommerce plugin
              window.ga('require', 'ecommerce');
            }

            tracking.ready(() => {
              // Do any other setup required
              // HEADS UP! Is there is an ad blocker on the page then this ready callback will not be called
              debug('ready');
            });
          })
      );

    return this.tracking;
  }

  setDefaultProperties(properties = {}) {
    debug('defaultProperties', { properties });

    this.defaultProperties = {
      ...this.defaultProperties,
      ...properties
    };
  }

  identify(userId = '', traits = {}, options = {}, callback = () => {}) {
    this.getTracking()
      .then(tracking => {
        debug('identify', { userId, traits, options });
        tracking.identify(userId, traits, options, callback);
      })
      .catch(err => {
        callback();
        throw err;
      });
  }

  track(event, properties = {}, options = {}, callback = () => {}) {
    const props = {
      ...properties,
      ...this.defaultProperties,
      date: ~~(Date.now() / 1000)
    };

    this.getTracking()
      .then(tracking => {
        debug('event', { event, props, options });
        tracking.track(event, props, options, callback);
      })
      .catch(err => {
        callback();
        throw err;
      });
  }

  alias(id) {
    this.getTracking().then(tracking => {
      debug('aliasing user', {
        to: id
      });
      tracking.alias(id);
    });
  }

  page(name = '', properties = {}, options = {}) {
    const props = {
      ...properties,
      ...this.defaultProperties,
      date: ~~(Date.now() / 1000)
    };

    this.getTracking().then(tracking => {
      debug('page', { name, props, options });
      tracking.page(name, props, options);
    });
  }

  reset() {
    if (__CLIENT__) {
      this.getTracking().then(tracking => {
        debug('reset');
        tracking.reset();
      });

      if (window.mixpanel) {
        window.mixpanel.reset();
      }
    }
  }
}

// Analytics singleton
const analytics = new Analytics();

export function track(
  event,
  properties = {},
  options = {},
  callback = () => {}
) {
  analytics.track(event, properties, options, callback);
}

export function page(name, properties = {}, options = {}) {
  analytics.page(name, properties, options);
}
